import type React from 'react';

import { Spinner, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

export const LoadingMessage: React.FC = () => {
	const { translate } = useI18n();

	return (
		<div
			data-testqa="loading-message"
			data-testid="loading-message"
			className="flex flex-col items-center justify-center gap-3 p-2 text-center"
			aria-label={translate(
				'corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.loading.aria_label',
			)}
		>
			<Spinner />
			<Text size="xx-small" variant="heading">
				<Translate value="corgi.petition.starter_dashboard_v2.ready_to_share.share_preview_modal.loading.message" />
			</Text>
		</div>
	);
};
